import { pgTable, text } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes } from '../common/utils'

export const skills = pgTable(
  'skills',
  {
    ...getBaseFields(),
    name: text().notNull().unique(),
    description: text(),
    category: text(),
  },
  (table) => getBaseIndexes('skills', table),
)
